export default "__VITE_ASSET__BOIGi3V0__"